module.exports = __webpack_public_path__ + "static/media/ar.78827b0b.svg";